// `/inbox` layout — Wave 5c.1.
//
// Mounts the inbox page below the `_authed` shell. The layout itself just
// renders the page; segment URLs (`/inbox` and `/inbox/$id`) all funnel
// into `InboxPage`, which reads the selected conversation id from search
// params (preferred) or from the route param.

import { Outlet, createRoute } from '@tanstack/react-router';

import { Route as AuthedLayoutRoute } from '../__layout';

export const Route = createRoute({
  getParentRoute: () => AuthedLayoutRoute,
  path: 'inbox',
  validateSearch: (search: Record<string, unknown>) => ({
    accountId: typeof search.accountId === 'string' ? search.accountId : undefined,
    mode: typeof search.mode === 'string' ? search.mode : undefined,
    selectedId: typeof search.selectedId === 'string' ? search.selectedId : undefined,
  }),
  component: InboxLayout,
});

function InboxLayout() {
  return <Outlet />;
}
